import { render, staticRenderFns } from "./BlogPostCardHero.vue?vue&type=template&id=408cade8"
import script from "./BlogPostCardHero.vue?vue&type=script&lang=js"
export * from "./BlogPostCardHero.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports